import { Injectable } from '@angular/core';
import {MouseEventsService} from "../mouseService/mouse-events.service";
import {BehaviorSubject, iif, timer} from "rxjs";
import {CesiumAdapterService} from "../cesiumAdapter21/cesium-adapter.service";
import {ItemManagerService} from "../itemManager/item-manager.service";
import {KeyListenersService} from "../keyListenersService/key-listeners.service";
import {filter, isEmpty, mergeMap} from "rxjs/operators";
import {Item} from "../../models/Item";
import {EsBsModalService} from "../bsModalService/bs-modal.service";
import {ConcreteLayerService} from "../concreteLayer/concrete-layer.service";
import {UiAdapterService} from "../uiAdapterService/ui-adapter.service";
import {ServerConnectionService} from "../serverConnection/server-connection.service";
import {GlobalEventsService} from "../global-events.service";
import * as turf from '@turf/turf';
import {Feature, Point, Polygon} from '@turf/turf';

@Injectable({
  providedIn: 'root'
})
export class MultiSelectItemsService {

  private isDown: any = false;
  private isChangedDynamically: boolean = false;
  private currentSelectingDOMElement:HTMLDivElement = null;
  private _isMultiSelectActive$ = new BehaviorSubject(false);
  private firstPoint = {x: 0, y: 0};
  private endPoint = {x: 0, y: 0};
  private resultRectangle = null;
  private dragSelectedItems = null;
  private _currentDraggableItemId = null;
  private dragWithKeyMsg: string;
  get currentDraggableItemId(){
    return this._currentDraggableItemId;
  }

  set currentDraggableItemId(val){
    if (Object.keys(this.im.selectedItemList).length > 1){
      this.server.setUnlimitedRequestCount();
    }
    this._currentDraggableItemId = val;
  }

  public multiSelectModalElm = '#multi-select-modal';
  public multiSelectMethod = null;

  get isMultiSelectActiveVal(){
    return this._isMultiSelectActive$.getValue();
  }

  get isMultiSelectActive$(){
    return this._isMultiSelectActive$.asObservable();
  }

  set isMultiSelectActive$(val:any){
    this._isMultiSelectActive$.next(val);
  }

  private isWatchEnabled(){
    return this.isDown && this.isMultiSelectActiveVal;
  }

  copyItemsToNewFloorplan(floorplan, isSwitchToFloorplan) {
    if (this.cs.selectedConcrete.id == floorplan) {
      alert(Yiit.t('You\'re trying to copy object(s) to the same floorplan, please select another one'));
      return;
    }
    const copyPromise = new Promise((resolve, reject) => {
      const copiesObj = {};
      for (const i in this.im.selectedItemList) {
        const selectedItem: Item = this.im.selectedItemList[i];
        ((dupItem) => this.im
          .duplicateItem(dupItem, true)
          .then((newItem: Item) => {
            copiesObj[newItem.getId()] = newItem;
            if (Object.keys(copiesObj).length === Object.keys(this.im.selectedItemList).length) {
              resolve(copiesObj);
            }
          }))(selectedItem);
      }
    });
    copyPromise.then((copiesObj) => {
      if (isSwitchToFloorplan) {
        this.im.clearSelectedItems();
        for (const i in copiesObj) {
          this.im.addToSelectedGroup(copiesObj[i]);
        }
      }
      this.setNewFloorplanForItems(floorplan, isSwitchToFloorplan, copiesObj);
    });
  }

  setNewFloorplanForItems(floorplanId, isSwitchToFloorplan, newItems?){
    if (this.cs.selectedConcrete.id == floorplanId) {
      alert(Yiit.t('You\'re trying to move object(s) to the same floorplan, please select another one'));
      return;
    }
    let currentItems = (newItems) ? newItems :this.im.selectedItemList;
    for (let i in currentItems){
      let _item:Item = currentItems[i];
      if (floorplanId){
        floorplanId = parseFloat(floorplanId);
      }
      _item.config.setConcreteLayerId(floorplanId);
      this.im.setNewItemGroupByConfig(_item);
      if (!isSwitchToFloorplan){
        _item.setVisibility(false);
      }
    }
    if (isSwitchToFloorplan){
      timer(500).subscribe(()=>{
        let firstItem:Item = currentItems[Object.keys(currentItems)[0]];
        this.ui.selectedItem$ = this.cs.getFloorplanById(firstItem.config.getConcreteLayerId());
      });
    }

    if (!isSwitchToFloorplan){
      this.im.clearSelectedItems();
      this.ui.selectedItem$ = null;
    }
  }
  openFloorplanModal(){
    this.bsModal.currentModal = this.multiSelectModalElm;
    this.bsModal.openModal()
  }

  constructor(private mouseListener: MouseEventsService,
              private adapter: CesiumAdapterService,
              private im: ItemManagerService,
              private keyS: KeyListenersService,
              private bsModal: EsBsModalService,
              private ui: UiAdapterService,
              private cs:ConcreteLayerService,
              private server: ServerConnectionService,
              private eventService: GlobalEventsService
  ) {
    this.dragWithKeyMsg = window['KEYBOARD_DRAG_MESSAGE'];
    this.initListeners();
  }

  private initListeners(){

    this.adapter.onMouseMovedDifference$.subscribe((offset)=>{
      if (Object.keys(this.im.selectedItemList).length > 1){
        let selectedItems = Object.values(this.im.selectedItemList).filter((item:Item)=>{
          return (item.getId() != this.currentDraggableItemId) && item.drag_enabled && !item.config.isCopy;
        });
        this.dragSelectedItems = selectedItems;
        selectedItems.forEach((i:Item)=>{
          i.getObservable(Item.MOVE_OBJECT_BY_OFFSET).next(offset);
        })
      }
      this._currentDraggableItemId = null;
    });

    this.adapter.dragEnd.subscribe(() => {
      if (this.dragSelectedItems) {
        this.dragSelectedItems.filter((i:Item)=>{
          if (!i.config.getInputProp('__objectArray', 'value')){
            return true;
          }
          return this._currentDraggableItemId != i.getId();

        }).forEach((i: Item) => {
          i.getObservable('updateMultiSelectDragPosition').next(true);
        });
      }
      this._currentDraggableItemId = null;
    });

    this.keyS.keyDown$.pipe(filter((event)=>{return Object.keys(this.im.selectedItemList).length > 0})).subscribe((event)=>{
      if (Object.keys(this.im.selectedItemList).length > 1){
        this.server.setUnlimitedRequestCount();
      }
        for (let i in this.im.selectedItemList){
          let item:Item = this.im.selectedItemList[i];
          if (item.drag_enabled || item.config.isCopy){
            item.getObservable(Item.OBJECT_OFFSET_WITH_DIRECTION).next(event);
          }
        }
      // }
    });

    this.mouseListener.isMouseDown$.subscribe((event:any)=>{
      this.isDown = event;
      if (this.isDown && !this.isMultiSelectActiveVal && this.keyS.isShiftOnlyDown()){
        this._isMultiSelectActive$.next(true);
        this.isChangedDynamically = true;
      }

      if (this.isMultiSelectActiveVal){
        //this is mouseUp
        if (!this.isDown){
          if (this.resultRectangle){
            this.im.clearSelectedGroup();
            let resultDegrees = this.adapter.getDegreesRectangleCoords(this.resultRectangle);
            let turfPoly:Feature<Polygon> = turf.polygon([
              [
                [resultDegrees.leftTop.longitude, resultDegrees.leftTop.latitude],
                [resultDegrees.rightTop.longitude, resultDegrees.rightTop.latitude],
                [resultDegrees.rightBottom.longitude, resultDegrees.rightBottom.latitude],
                [resultDegrees.leftBottom.longitude, resultDegrees.leftBottom.latitude],
                [resultDegrees.leftTop.longitude, resultDegrees.leftTop.latitude],
              ],
            ]);
            let itemList = this.im.getItemsWithFloorplanId((this.cs.selectedConcrete) ? this.cs.selectedConcrete.id : null);
            itemList.forEach((_item)=>{
              let position = _item.config.getObjectConfig().getPosition() || _item.config.getObjectConfig().getCenterPosition();
              let turfPoint:Feature<Point> = turf.point([position.longitude, position.latitude]);
              if (turf.booleanPointInPolygon(turfPoint, turfPoly)){
                this.im.addToSelectedGroup(_item);
              }
            });
            if (Object.keys(this.im.selectedItemList).length > 0){
              this._isMultiSelectActive$.next(false);
            }
          }
          this.removeSelectingDOMElement();
          this.adapter.changeCameraMove(true);

          if (this.isChangedDynamically){
            this.isChangedDynamically = false;
            this._isMultiSelectActive$.next(false);
          }

          if (!this.eventService.isSomeHintVisible) {
            this.eventService.ToastNotificationEvent.emit({
              message: this.dragWithKeyMsg,
              position: {bottom: '10px', left: '80px'},
              autoHide: false,
              title: 'Move hint',
              classes: ['notification']
            });
            this.eventService.isSomeHintVisible = true;
          }

          if (!this.eventService.isSomeHintVisible) {
            this.eventService.ToastNotificationEvent.emit({
              message: this.dragWithKeyMsg,
              position: {bottom: '10px', left: '80px'},
              autoHide: false,
              title: 'Move hint',
              classes: ['notification']
            });
            this.eventService.isSomeHintVisible = true;
          }
        }
        if (this.isDown && event.target.tagName.toLowerCase() == 'canvas'){
          this.adapter.changeCameraMove(false);
          this.firstPoint = {x: this.isDown.clientX, y:this.isDown.clientY};
          this.endPoint = {x: this.isDown.clientX, y:this.isDown.clientY};
          this.createSelectingDOMElement();
        }
      }
    });

    this.mouseListener.isMouseMove$.subscribe((event)=>{
      if (this.isWatchEnabled() && this.currentSelectingDOMElement){
        this.endPoint = {x: event.clientX, y: event.clientY};
        this.reDrawRectangle();
      }
    })
  }

  private createSelectingDOMElement(){
    let div = document.createElement('div');
    div.style.cssText = 'position: fixed; z-index: 999; left: '+this.firstPoint.x+'px; top: '+this.firstPoint.y+'px; border: 5px solid #EB6432; width: 1px; height: 1px; background: rgba(235, 100, 50, 0.4);';
    document.querySelector('body .wrap #es-cesium-container').appendChild(div);
    this.currentSelectingDOMElement = div;
  }

  private removeSelectingDOMElement(){
    if (this.currentSelectingDOMElement){
      this.currentSelectingDOMElement.remove();
    }
    this.currentSelectingDOMElement = null;
    this.resultRectangle = null;
  }

  private reDrawRectangle(){
    let minPoint = {x: Math.min(this.firstPoint.x,this.endPoint.x), y: Math.min(this.firstPoint.y,this.endPoint.y)};
    let maxPoint = {x: Math.max(this.firstPoint.x,this.endPoint.x), y: Math.max(this.firstPoint.y,this.endPoint.y)};
    this.currentSelectingDOMElement.style.left = minPoint.x + 'px';
    this.currentSelectingDOMElement.style.top = minPoint.y + 'px';
    this.currentSelectingDOMElement.style.width = maxPoint.x - minPoint.x + 'px';
    this.currentSelectingDOMElement.style.height = maxPoint.y - minPoint.y + 'px';
    this.resultRectangle = {
      leftTop: {x: minPoint.x, y: minPoint.y - 64},
      rightBottom: {x: maxPoint.x, y: maxPoint.y - 64},
    };
  }
}
